<template>
  <div>
    <Widget>
      <form-wizard
        shape="tab"
        color="#3498db"
        title=""
        subtitle=""
        @on-change="updateProgress"
        @on-loading="updateProgress(1, 1)"
      >
        <b-progress class="progress-xs" variant="info" :value="progress" :max="2" />
        <b-button slot="prev" id="prev-form" variant="primary" class="text-white" hidden>
          <i class="fa fa-caret-left" /> Sebelumnya
        </b-button>
        <b-button slot="next" id="next-form" variant="primary" class="text-white" hidden>
          Selanjutnya <i class="fa fa-caret-right" />
        </b-button>
        <b-button slot="finish" id="finish-form" variant="success" class="text-white" hidden>
          Selesai <i class="fa fa-check" />
        </b-button>

        <tab-content title="Form Penilaian">
          <FormPenilaian v-if="progress === 1" ref="form1" />
        </tab-content>

        <tab-content title="Catatan Dalam Penilaian">
          <FormCatatanDalamPenilaian v-if="progress === 2" ref="form2" />
        </tab-content>

        <div class="d-flex justify-content-between" style="padding: 14px 20px 14px 20px">
          <b-button @click="btnBack" id="btn_back" v-if="progress === 1" variant="danger" style="color: white">
            Kembali
          </b-button>
          <b-button id="btn_previews" v-else @click="prevForm" variant="primary">
            <i class="fa fa-caret-left" /> Sebelumnya
          </b-button>

          <b-button id="btn_next" @click="nextForm" variant="primary" style="float: right" :hidden="!(progress !== 2)">
            Selanjutnya <i class="fa fa-caret-right" />
          </b-button>
          <b-button
            id="btn_finish"
            @click="nextForm"
            variant="success"
            style="float: right"
            :hidden="!(progress === 2)"
          >
            Selesai <i class="fa fa-check" />
          </b-button>
        </div>
      </form-wizard>
    </Widget>
  </div>
</template>

<style>
.wizard-nav li {
  pointer-events: none;
}

.input-units {
  position: relative;
  overflow: hidden;
}

.input-units .text-units {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 0px;
  margin: 0.375rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0);
}

.input-units .text-units span:first-child {
  visibility: hidden;
}
</style>

<script>
import Vue from 'vue'
import Widget from '@/components/Widget/Widget'
import FormPenilaian from './formPenilaian.vue'
import FormCatatanDalamPenilaian from './formCatatanDalamPenilaian.vue'
import { Validator } from 'vee-validate'
import FormBA from './formBA.vue'

export default {
  components: {
    Widget,
    FormPenilaian,
    FormCatatanDalamPenilaian,
    FormBA,
  },
  data() {
    return {
      progress: 1,
      id_penilaian: null,
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      form: [{}, {}, {}],
      update: false,
    }
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: () => 'Email tidak valid',
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  methods: {
    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) {
        Vue.set(this, 'progress', nextIndex + 1)
      }
    },

    prevForm() {
      document.getElementById('prev-form').click()
    },

    async nextForm() {
      if (this.progress === 1) {
        if (await this.$refs.form1.nextForm()) {
          document.getElementById('next-form').click()
        }
      } else if (this.progress === 2) {
        if (await this.$refs.form2.nextForm()) {
          this.$router.push('/app/penilaian-laporan-tahunan')
        }
      }
    },

    updateForm(val, index) {
      this.form[index] = val
    },

    btnBack() {
      this.$router.push('/app/penilaian-laporan-tahunan')
    },
  },
}
</script>
